import { useCallback } from 'react';
import { sdk } from '@mesa-labs/mesa-api';
import useAuthStore from '../store/authStore';

export function usePermissions() {
  const permissions = useAuthStore((s) => s.permissions);

  const hasPermissions = useCallback(
    (perms: sdk.AuthPermission[]): boolean => {
      return !!permissions && perms.every(p => permissions.includes(p));
    },
    [permissions],
  );
  const hasPermission = useCallback(
    (perm: sdk.AuthPermission): boolean => {
      return !!permissions && permissions.includes(perm);
    },
    [permissions],
  );
  const hasAnyPermission = useCallback(
    (perms: sdk.AuthPermission[]): boolean => {
      return !!permissions && perms.some(p => permissions.includes(p));
    },
    [permissions],
  );

  return {
    permissions,
    hasPermissions,
    hasPermission,
    hasAnyPermission,
    hasDashboardAccess: hasAnyPermission([sdk.AuthPermission.InvoicesRead, sdk.AuthPermission.VendorsRead, sdk.AuthPermission.ClientsRead]),
    hasDevelopersAccess: hasAnyPermission([sdk.AuthPermission.ConfigRead, sdk.AuthPermission.WebhooksRead, sdk.AuthPermission.ApiKeysRead]),
  };
}
